const getRandomItemFromGivenArray = (arr: []) => arr[Math.floor(Math.random() * arr.length)];
const getRandomIndex = (arrayLength: number) => Math.floor(Math.random() * arrayLength);

export { getRandomItemFromGivenArray, getRandomIndex };
